import { useTranslation } from 'react-i18next';
import { persistLang } from '@/i18n/detect';

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();

  const toggle = () => {
    const next = i18n.language.startsWith('ja') ? 'en' : 'ja';
    i18n.changeLanguage(next);
    persistLang(next);
  };

  const isJa = i18n.language.startsWith('ja');
  return (
    <button
      className="btn-primary"
      onClick={toggle}
      aria-label={t('lang-toggle')}
      aria-pressed={isJa}
      style={{ whiteSpace: 'nowrap' }}
    >
      <span style={{ textDecoration: isJa ? undefined : 'underline' }}>
        {t('lang-en')}
      </span>
      {' / '}
      <span style={{ textDecoration: isJa ? 'underline' : undefined }}>
        {t('lang-ja')}
      </span>
    </button>
  );
}
